import {DifficultSummary} from '@domain/pom'

export const getAnswered = (score?: DifficultSummary): number => score?.answeredPositively ?? 0

export const getTotal = (score?: DifficultSummary): number => score?.questionCount ?? 0
